import { Box, Typography } from "@mui/material"

export const BasicTraining = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={0.5}
      p={1.5}
      width='100%'
      sx={{
        bgcolor: (theme) => theme.palette.primary._states.hover,
      }}
    >
      <Typography variant='h6'>
      Basic Training Material
      </Typography>
      <Typography variant="body2">
      *At least one document or weblink is required to create an AI Persona.
      </Typography>
    </Box>
  )
}
